export function extendNumberWheel() {
  if (lib.comsuntexsymbolsNumberWheel) {
    const comsuntexsymbolsNumberWheel_constructor =
      lib.comsuntexsymbolsNumberWheel;
    const comsuntexsymbolsNumberWheel_prototype =
      lib.comsuntexsymbolsNumberWheel.prototype;

    lib.comsuntexsymbolsNumberWheel = function () {
      this._oldConstructor = comsuntexsymbolsNumberWheel_constructor;
      this._oldConstructor();

      this.spinner.square.regX = 0;
      this.spinner.square.regY = 0;
      this.spinner.square.x = 0;
      this.spinner.square.y = 0;

      UIUtil.hide(this.white);
      UIUtil.hide(this.redBg);
      UIUtil.hide(this.veil2);

      this.clockwise = true;
      this.squareDisplayed = false;
      this.dragStartQuad = -1;
      this.onSelect = null;
    };
    lib.comsuntexsymbolsNumberWheel.prototype =
      comsuntexsymbolsNumberWheel_prototype;

    const p = lib.comsuntexsymbolsNumberWheel.prototype;

    p.setClockwise = function (clockwise) {
      this.clockwise = clockwise;
    };

    p.displayValues = function (values) {
      this._displayValue(this.valueUp, values[0]);
      this._displayValue(this.valueRight, values[this.clockwise ? 1 : 3]);
      this._displayValue(this.valueDown, values[2]);
      this._displayValue(this.valueLeft, values[this.clockwise ? 3 : 1]);
    };

    p._displayValue = function (valueText, value) {
      if (Calculator.isDefined(value) && value != null) {
        if (Calculator.isNumber(value)) {
          valueText.displayValue(value);
        } else {
          valueText.displayText(value);
        }
      } else {
        valueText.clear();
      }
    };

    /* Visual */

    p.open = function (ms) {
      UIUtil.hide(this.redBg);
      this.spinner.rotation = this.clockwise ? 45 : -45;
      UIUtil.tween(this.spinner, 'rotation', 0, ms);
      UIUtil.hide(this.veil, ms);
    };

    p.close = function (ms) {
      if (ms == null) ms = 0;
      this.spinner.rotation = 0;
      UIUtil.tween(this.spinner, 'rotation', this.clockwise ? 45 : -45, ms);
      UIUtil.show(this.veil, ms);
    };

    p.reset = function (ms) {
      if (ms == null) ms = 0;
      UIUtil.hide(this.redBg);
      UIUtil.show(this.veil, ms);
      UIUtil.tween(
        this.spinner,
        'rotation',
        this.clockwise ? 135 : -135,
        ms,
        'strongInOut',
      );
    };

    p.glow = function (ms) {
      if (ms == null) ms = 0;
      UIUtil.tween(
        this.spinner,
        'rotation',
        this.clockwise ? 270 : -270,
        ms,
        'easeInOut',
      );

      UIUtil.show(this.veil, ms);
      UIUtil.show(this.white, ms);
    };

    p.flashRed = function (ms) {
      if (ms == null) ms = 0;
      UIUtil.show(this.redBg);
      UIUtil.hide(this.redBg, ms);
    };

    p.spinnerToSquare = function (ms) {
      if (!this.squareDisplayed) {
        this.squareDisplayed = true;
        if (ms == null) ms = 0;
        UIUtil.scaleTo(this.spinner.square, 3.5, ms);
        UIUtil.show(this.veil2, ms);
      }
    };

    p.squareToSpinner = function (ms) {
      if (this.squareDisplayed) {
        this.squareDisplayed = false;
        if (ms == null) ms = 0;
        UIUtil.scaleTo(this.spinner.square, 1.0, ms);
        UIUtil.hide(this.veil2, ms);
      }
    };

    /* Controls */

    p.disable = function (ms) {
      if (ms == null) ms = 0;
      UIUtil.disable(this);
      UIUtil.fadeTo(this.white, 0.4, ms);
    };

    p.enable = function (ms) {
      if (ms == null) ms = 0;
      UIUtil.enable(this);
      UIUtil.fadeTo(this.white, 0, ms);
    };

    p.enableQuadrantSelection = function (onSelect) {
      this.onSelect = onSelect;
      const mc = this;
      this.mouseChildren = false;
      this.addEventListener('mousedown', function (e) {
        mc._wheelMouseDown(e);
      });
      this.addEventListener('pressmove', function (e) {
        if (mc.dragStartQuad > -1) {
          const p = UIUtil.globalToLocal(mc, e.stageX, e.stageY);
          const q = mc._getWheelQuadrant(p.x, p.y);
          mc.displaySelection(mc.dragStartQuad, q, 0.7);
        }
      });
      this.addEventListener('pressup', function (e) {
        mc._wheelMouseUp(e);
      });
      this.addEventListener('mouseout', function (e) {
        if (mc.dragStartQuad > -1) {
          mc.clearSelection();
        }
      });
      UIUtil.useHandCursor(this);
    };

    p.displaySelection = function (quad1, quad2, alpha) {
      if (alpha == null) alpha = 1.0;

      this.clearSelection();
      this.glowQuad(quad1);
      this.glowQuad(quad2);

      if (quad1 > -1 && quad2 > -1) {
        let arrowFrame = 1;
        if (!this.clockwise) {
          if (quad1 == 3) quad1 = 1;
          else if (quad1 == 1) quad1 = 3;
          if (quad2 == 3) quad2 = 1;
          else if (quad2 == 1) quad2 = 3;
        }
        switch (quad1 + ' ' + quad2) {
          case '0 1':
            arrowFrame = 2;
            break;
          case '0 2':
            arrowFrame = 3;
            break;
          case '0 3':
            arrowFrame = 4;
            break;
          case '1 0':
            arrowFrame = 5;
            break;
          case '1 2':
            arrowFrame = 6;
            break;
          case '1 3':
            arrowFrame = 7;
            break;
          case '2 0':
            arrowFrame = 8;
            break;
          case '2 1':
            arrowFrame = 9;
            break;
          case '2 3':
            arrowFrame = 10;
            break;
          case '3 0':
            arrowFrame = 11;
            break;
          case '3 1':
            arrowFrame = 12;
            break;
          case '3 2':
            arrowFrame = 13;
            break;
        }
        UIUtil.fadeTo(this.arrows, alpha);
        UIUtil.setFrame(this.arrows, arrowFrame);
      }
    };

    p.glowQuad = function (quad) {
      if (!this.clockwise) {
        if (quad == 3) quad = 1;
        else if (quad == 1) quad = 3;
      }
      switch (quad) {
        case 0:
          this.valueUp.glow();
          break;
        case 1:
          this.valueRight.glow();
          break;
        case 2:
          this.valueDown.glow();
          break;
        case 3:
          this.valueLeft.glow();
          break;
      }
    };

    p.clearSelection = function () {
      this.valueUp.clearGlow();
      this.valueRight.clearGlow();
      this.valueDown.clearGlow();
      this.valueLeft.clearGlow();
      UIUtil.setFrame(this.arrows, 1);
    };

    /* Mouse Event Handlers */

    p._wheelMouseDown = function (e) {
      const p = UIUtil.globalToLocal(this, e.stageX, e.stageY);
      const q = this._getWheelQuadrant(p.x, p.y);
      this.dragStartQuad = q;
    };

    p._wheelMouseUp = function (e) {
      const p = UIUtil.globalToLocal(this, e.stageX, e.stageY);
      const q = this._getWheelQuadrant(p.x, p.y);
      this.onSelect(this, this.dragStartQuad, q);
      //displayArrows(this.dragStartQuad, q);
      this.dragStartQuad = -1;
    };

    p._getWheelQuadrant = function (x, y) {
      let q = -1;
      if (y > 0) {
        if (x > y) q = 1;
        else if (-x > y) q = 3;
        else q = 2;
      } else {
        if (x > -y) q = 1;
        else if (-x > -y) q = 3;
        else q = 0;
      }
      if (!this.clockwise) {
        if (q == 1) q = 3;
        else if (q == 3) q = 1;
      }

      return q;
    };
  }
}
